import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";

export function getVerticalAlignment(settings: ChartStyleSettings) {
  return settings.legend?.verticalAlignment || "top";
}
